import { Controller } from '@hotwired/stimulus';
import List from 'list.js';

export default class extends Controller {
  static targets = ['table']

  connect() {
    if (!this.hasTableTarget) { return; }

    const headerLinks = this.tableTarget.querySelectorAll('th a');

    headerLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
      });
    });

    new List(this.tableTarget.id, $(`#${this.tableTarget.id}`).data('options'));
  }
}
